/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {
  GetReceiveNoteResponse,
  ReceiveNoteAuditSlice,
  ReceiveNoteDeliveryNoteSlice,
  ReceiveNoteGeneralInfoSlice,
  ReceiveNoteInfoSlice,
  ReceiveNoteMarkersSlice,
  ReceiveNoteStateSlice,
} from './types';

export const sliceReceiveNoteState = (response: GetReceiveNoteResponse): ReceiveNoteStateSlice => ({
  receiveNoteId: response.receiveNoteId,
  receiveNoteNumber: response.receiveNoteNumber,
  state: response.state,
  type: response.type,
  completedAt: response.completedAt,
  completedBy: response.completedBy,
});

export const sliceReceiveNoteGeneralInfo = (
  response: GetReceiveNoteResponse
): ReceiveNoteGeneralInfoSlice => ({
  supplierId: response.supplierId,
  warehouseId: response.warehouseId,
  authorizationProfileId: response.authorizationProfileId,
  transferSourceBranchId: response.transferSourceBranchId,
  branchId: response.branchId,
  sourceBranchId: response.sourceBranchId,
  invoiceNumber: response.invoiceNumber,
  invoiceIssueDate: response.invoiceIssueDate,
  paymentType: response.paymentType,
  currency: response.currency,
  exchangeRate: response.exchangeRate,
  ncConversion: response.ncConversion,
  note: response.note,
});

export const sliceReceiveNoteDeliveryNote = (
  response: GetReceiveNoteResponse
): ReceiveNoteDeliveryNoteSlice => ({
  deliveryNote: response.deliveryNote,
});

export const sliceReceiveNoteMarkers = (
  response: GetReceiveNoteResponse
): ReceiveNoteMarkersSlice => ({
  markers: response.markers,
  isFastTrackTabEnable: response.isFastTrackTabEnable,
});

export const sliceReceiveNoteAudit = (response: GetReceiveNoteResponse): ReceiveNoteAuditSlice => ({
  createdAt: response.createdAt,
  createdBy: response.createdBy,
  updatedAt: response.updatedAt,
  updatedBy: response.updatedBy,
});

export const sliceReceiveNoteInfo = (response: GetReceiveNoteResponse): ReceiveNoteInfoSlice => ({
  ...sliceReceiveNoteGeneralInfo(response),
  ...sliceReceiveNoteDeliveryNote(response),
  ...sliceReceiveNoteMarkers(response),
  ...sliceReceiveNoteAudit(response),
});
